import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { StudentType } from "../../../types/Student";
import { get } from "../../../utils/axios-config";
import { DUPLICATED_SCHOOL_CODES, STUDENTS_SUBSCRIPTIONS_SUBJECTS, STUDENTS_UNSYNCED } from "../../../utils/constants";

export const getStudentSubscriptionsSubjects = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdAcademicYear ? { IdAcademicYear: data.IdAcademicYear  } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse  } : {}),
        ...(data?.IdSubject ? { IdSubject: data.IdSubject  } : {}),
        ...(data?.Semester ? { Semester: `${data.Semester}`  } : {}),
        ...(data?.Level ? { Level: `${data.Level}`  } : {}),
        ...(data?.Regime ? { Regime: `${data.Regime}`  } : {}),
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),
        ...(data?.IdClass ? { IdClass: data.IdClass } : {}),
    });
    const url = `${STUDENTS_SUBSCRIPTIONS_SUBJECTS}?${queryParams.toString()}`;
    return await get<PagedResultsType<StudentType>>(url)
};


export const getStudentUnsynced = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.SearchTerm ? { SearchTerm: data.SearchTerm } : {}),
    });
    const url = `${STUDENTS_UNSYNCED}?${queryParams.toString()}`;
    return await get<PagedResultsType<any>>(url)
};

export const getStudentDuplicatedSchoolCodes = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${DUPLICATED_SCHOOL_CODES}?${queryParams.toString()}`;
    return await get<PagedResultsType<any>>(url)
};


